export enum NISOO2ProgramRequestSort {
    EnvelopeDate = 1,
    InstitutionName = 2,
    EducationSectorName = 3,
    ProgramRequestTypeName = 4,
    ReceivedBy = 5,
    ProgramRequestDate = 6,
}